import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const ReactQueryDevtools = lazy(() =>
  import("@tanstack/react-query-devtools").then((module) => ({
    default: module.ReactQueryDevtools,
  })),
);

const container = document.getElementById("root");

if (!container) throw new Error("Root container not found");

const root = ReactDOM.createRoot(container);

root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </AuthProvider>
      {process.env.NODE_ENV === "development" && (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
        </Suspense>
      )}
    </QueryClientProvider>
  </BrowserRouter>
);

// Register service worker for PWA functionality with smart update handling
serviceWorkerRegistration.register({
  onSuccess: () => {
  },
  onUpdate: (registration) => {
    // Activate the new service worker
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
    // Note: We DON'T auto-reload here anymore
    // The user can manually refresh when they want
    // Or it will update on next page load
  },
});

// Setup PWA install prompt
serviceWorkerRegistration.setupInstallPrompt();
